// Brand & integration config. Values are publicly visible (not secrets).
// CRA bakes REACT_APP_* env vars at build time; the literals below act as fallbacks.

export const SITE = {
  brand: "Green Financials",
  logo: "https://customer-assets.emergentagent.com/job_luxury-wealth/artifacts/z9qugr97_362100.png",
  whatsappNumber:
    process.env.REACT_APP_WHATSAPP_NUMBER || "12819696440",
  whatsappDisplay: "+1 (281) 969-6440",
  whatsappMessage:
    "Hi Green Financials, I'd like to learn more about your strategies.",
  calendlyUrl:
    process.env.REACT_APP_CALENDLY_URL ||
    "https://calendly.com/admingreenfinancials?background_color=000000&text_color=ffffff&primary_color=006241",
  navLinks: [
    { label: "Protection", href: "#protection" },
    { label: "Wealth", href: "#wealth" },
    { label: "Careers", href: "#careers" },
    { label: "Contact", href: "#contact" },
  ],
  images: {
    heroPortrait:
      "https://customer-assets.emergentagent.com/job_luxury-wealth/artifacts/4a6fkpiq_362120.png",
    architecture1:
      "https://images.unsplash.com/photo-1767950470198-c9cd97f8ed87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    architecture2:
      "https://images.unsplash.com/photo-1776935359460-6c789e972e6a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    avatar1:
      "https://images.unsplash.com/photo-1770452603217-89b4f03e8271?crop=entropy&cs=srgb&fm=jpg&q=85&w=400",
  },
};

export const whatsappLink = (msg) => {
  const text = encodeURIComponent(msg || SITE.whatsappMessage);
  return `https://api.whatsapp.com/send?phone=${SITE.whatsappNumber}&text=${text}`;
};

export const openWhatsApp = (msg) => {
  const url = whatsappLink(msg);
  const w = window.open(url, "_blank", "noopener,noreferrer");
  if (!w || w.closed || typeof w.closed === "undefined") {
    window.location.href = url;
  }
};
